import { useMemo } from 'react';

import { FeatureFilterField, FeatureName } from '__generated__/GQL';
import useCanCompanyUserAccessFeature from 'common/hooks/useCanCompanyUserAccessFeature';
import { MemberInformationFormProps } from 'features/Team/components/MemberInformationRoleForm';
import { EDITABLE_ROLES } from 'features/Team/components/MemberInformationRoleForm/schema';

import {
  canSelectRole,
  mapEditableRoleToRole,
  mapEditableRoleToTransitionRole,
} from './utils';

export const useInvitationTransitions = () => {
  const { canAccessFeature } = useCanCompanyUserAccessFeature();

  const transitions: MemberInformationFormProps['roleTransitions'] = useMemo(
    () =>
      new Map(
        EDITABLE_ROLES.map((role) => [
          mapEditableRoleToTransitionRole(role),
          canSelectRole({
            hasAuthorization: canAccessFeature({
              name: FeatureName.TeamMembersInvite,
              where: {
                or: [
                  {
                    field: FeatureFilterField.Role,
                    values: [mapEditableRoleToRole(role)],
                  },
                ],
              },
            }),
            role: mapEditableRoleToTransitionRole(role),
          }),
        ]),
      ),
    [canAccessFeature],
  );

  return transitions;
};
